var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-header",style:({ 'top': _vm.topPos })},[_c('div',{staticClass:"content",style:({ 'height': _vm.computedHeight })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }